jQuery(window).load(function() {
	
	jQuery('body').addClass('loaded');
			
});
